import axios from 'axios';
import qs from 'qs';

// Prod (Docker): empty → same-origin /api via nginx.
// Local: REACT_APP_API_URL=http://localhost:5000
const API_ORIGIN = process.env.REACT_APP_API_URL || '';

const http = axios.create({
  baseURL: API_ORIGIN,
  withCredentials: true,
  paramsSerializer: {
    serialize: (params) =>
      qs.stringify(params, {
        encode: true,
        arrayFormat: 'repeat',
        indices: false,
      }),
  },
});

http.interceptors.request.use(async (config) => {
  const token = getCookie('XSRF-TOKEN');
  if (token) config.headers['X-CSRF-Token'] = token;
  return config;
});

http.interceptors.response.use(
  (r) => r,
  async (err) => {
    const original = err.config;
    if (err.response && err.response.status === 401 && !original._retry) {
      original._retry = true;
      try {
        const headers = {};
        const csrf = getCookie('XSRF-TOKEN');
        if (csrf) headers['X-CSRF-Token'] = csrf;
        await axios.post(`${API_ORIGIN}/api/auth/refresh`, {}, { withCredentials: true, headers });
        return http(original);
      } catch (_) { /* fall through */ }
    }
    return Promise.reject(err);
  }
);

function getCookie(name) {
  const m = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
  return m ? decodeURIComponent(m[2]) : null;
}

export default http;
